export default {
    // market
    tabNews: '新闻',
    tabJobPostings: '职位发布',
    marketSort: "排序",
    marketFilter: "过滤",
    marketReset: '重置',
    marketFilterGalleries: '领域',
    marketFilterCategories: '分类',
    recent: "近期",
    earlier: "更早",
    minuteAgo: "{count} 分钟之前",
    hourAgo: "{count} 小时之前",
    dayAgo: "{count} 天之前",
    weekAgo: "{count} 周之前",
    on: '来自',
    readArticle: "阅读文章",
    viewPosting: '查看招聘',
    moreNumber: "更多 {count} 家公司",


    // empty content text
    noNewsArticlesFound: "未找到新闻文章",
    nothingMatchSearch: "看起来我们找不到任何与您的搜索匹配的内容。尝试不同的关键字或稍后查看最新更新！",
    noJobListingsAvailable: "没有可用的职位列表",
    noJobPostingsMatching: "看起来没有符合您搜索条件的招聘信息。尝试不同的关键字或稍后回来探索新的机会。",
    noAdsFound: "未找到广告",
    noAdsFoundDesc: "当前未检测到相关广告，稍后回来查看最新投放动态。",
    noActivitiesTrackedYet: '尚未跟踪任何活动',
    noAdsMatch: "暂无符合搜索的广告",
    noAdsMatchDesc: "未找到与您的搜索匹配的广告。试着调整关键词，或稍后查看新的投放。",
    noTrackedAnyActivities: "我们还没有跟踪这家公司的任何活动。稍后查看更新",
    noTechnologiesFound: '未找到技术',
    cantFindAnyInformationOnTheTechnologies: "我们找不到这家公司使用的技术的任何信息。请继续关注更新。",


    // company info
    seeLess: "收起",
    seeMore: "展开",

};